export default "__VITE_ASSET__ewg6IgCw__"